import { Button, Col, InputNumber, Row } from "antd";
import React from "react";
const IncomeStaffInput = ({ max, value, setValue }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (e) => {
    setValue(e);
    // console.log(e);
  };

  const handleMax = () => {
    setValue(max);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderSetMax = (
    <Button type="text" onClick={handleMax}>
      Max
    </Button>
  );
  // -------------------------- MAIN --------------------------
  return (
    <Col span={24}>
      <Row justify="space-between" align="middle">
        <Col flex="auto">Input income:</Col>
        <Col span={16}>
          <InputNumber
            size="large"
            style={{ width: "100%" }}
            controls={false}
            max={max}
            value={value}
            onChange={handleChange}
            addonAfter={max > 0 ? renderSetMax : null}
            inputMode="numeric"
          />
        </Col>
      </Row>
    </Col>
  );
};
export default IncomeStaffInput;
